_ = require 'underscore'
Auth = require 'db/auth'
PluginRunner = require 'views/internal/plugins/plugin-runner'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
PluginView = require 'views/plugin/plugin-view'

module.exports = class PluginButtonsView extends PluginView
  buttonsSelector: '.js-button-list'
  buttonView: null

  initialize: ->
    @requestButtonsDebounced = _.debounce =>
      @requestButtons()
    , 1000

  hideContainer: (pluginButtons) ->
    pluginButtons.length == 0

  renderContainer: ->
    @$el

  runnerOptions: ->
    throw Error('runnerOptions not specified')

  requestButtons: ->
    PluginRunner.all @runnerOptions()
    .then (pluginButtons) =>
      # filter buttons down based on condition prop
      pluginButtons = _.filter pluginButtons, (pluginButton) =>
        # drop anything that doesn't appear to be a button object
        if _.isArray(pluginButton) || !_.isObject(pluginButton) || !pluginButton?.text
          return false

        if !pluginButton.condition?
          return @model.editable()

        switch pluginButton.condition
          when 'admin'
            if @model.typeName == 'Card'
              @model.getBoard().owned()
            else if @model.typeName == 'Board'
              @model.owned()
            else
              false
          when 'edit' then @model.editable()
          when 'readOnly' then !@model.editable()
          when 'signedIn' then Auth.isLoggedIn()
          when 'signedOut' then !Auth.isLoggedIn()
          when 'always' then true
          else false # unknown condition

      $target = @renderContainer()

      @$el.toggleClass('hide', @hideContainer(pluginButtons))

      @removeSubviews()

      subviews = _.sortBy(pluginButtons, 'text').map (pluginButton, index) =>
        @subview @buttonView, @model, { pluginButton }, index
      @appendSubviews subviews, $target

  vigor: @VIGOR.NONE
  renderOnce: ->
    options = @runnerOptions()

    @subscribe pluginsChangedSignal(options.board, options.card), @requestButtonsDebounced

    @



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-buttons-view.coffee